"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var Components_1 = require("./Components");
var LunchItems_1 = __importDefault(require("./Components/LunchItems"));
var ListPrice_1 = __importDefault(require("./Components/ListPrice"));
var editor_1 = require("./utils/editor");
var infopages_1 = require("./utils/infopages");
var Products_1 = __importDefault(require("./Components/Products"));
var values_1 = require("./utils/values");
var conditions_1 = require("./utils/conditions");
var componentTypes = {
    div: Components_1.Div,
    text: Components_1.Text,
    image: Components_1.Image,
    video: Components_1.Video,
    date: Components_1.Date,
    listPrice: ListPrice_1.default,
    lunchGroups: Components_1.LunchGroups,
    lunchItemsContainer: LunchItems_1.default,
    priceItems: Components_1.PriceItems,
    fishItems: Components_1.FishItems,
    keskoFeedOffers: Components_1.KeskoFeedOffers,
    keskoProductOffers: Components_1.KeskoProductOffers,
    meatItems: Components_1.MeatItems,
    products: Products_1.default,
    productData: Components_1.ProductData,
    qrCode: Components_1.QrCode
};
/**
 * Get render's supported template component type
 */
var getTemplateComponentType = function (type) {
    if (type === seesignage_utils_1.ComponentType.div ||
        type === seesignage_utils_1.ComponentType.text ||
        type === seesignage_utils_1.ComponentType.image ||
        type === seesignage_utils_1.ComponentType.video ||
        type === seesignage_utils_1.ComponentType.date ||
        type === seesignage_utils_1.ComponentType.listPrice ||
        type === seesignage_utils_1.ComponentType.lunchGroups ||
        type === seesignage_utils_1.ComponentType.lunchItemsContainer ||
        type === seesignage_utils_1.ComponentType.priceItems ||
        type === seesignage_utils_1.ComponentType.fishItems ||
        type === seesignage_utils_1.ComponentType.keskoFeedOffers || // NOTE: KeskoFeedOffers and KeskoProductOffers will be deprecated soon. As template editor support creating feed templates
        type === seesignage_utils_1.ComponentType.keskoProductOffers ||
        type === seesignage_utils_1.ComponentType.meatItems ||
        type === seesignage_utils_1.ComponentType.products ||
        type === seesignage_utils_1.ComponentType.productData ||
        type === seesignage_utils_1.ComponentType.qrCode) {
        return componentTypes[type];
    }
};
var getBackgroundStyle = function (currentTemplate, mediaKeys) {
    var backgroundImageKey = (0, ramda_1.path)(['backgroundImage'], currentTemplate);
    return backgroundImageKey
        ? {
            backgroundImage: "url(".concat(mediaKeys[backgroundImageKey], ")")
        }
        : undefined;
};
var RecursiveTemplateSchema = function (_a) {
    var currentComponentSchema = _a.currentComponentSchema, currentTemplate = _a.currentTemplate, mediaKeys = _a.mediaKeys, items = _a.items, infopageContent = _a.infopageContent, contentMetadata = _a.contentMetadata, chain = _a.chain, listPrice = _a.listPrice, additionalProps = _a.additionalProps, editorConfigurations = _a.editorConfigurations;
    var componentChildren = (0, ramda_1.path)(['children'], currentComponentSchema);
    var currentTemplateChildren = (0, ramda_1.path)(['children'], currentTemplate);
    var CurrentComponent = getTemplateComponentType(currentComponentSchema.type);
    var currentComponentStyles = __assign(__assign(__assign({}, getBackgroundStyle(currentTemplate, mediaKeys)), (0, ramda_1.path)(['styles'], currentTemplate)), ((editorConfigurations === null || editorConfigurations === void 0 ? void 0 : editorConfigurations.highlightElements)
        ? __assign({}, (0, editor_1.getHighlightElementStyles)(editorConfigurations === null || editorConfigurations === void 0 ? void 0 : editorConfigurations.highlightElementsColor)) : {}));
    var customAttributes = {};
    if (CurrentComponent === Components_1.Text) {
        customAttributes = {
            value: additionalProps && currentComponentSchema.customValue
                ? (0, values_1.getCustomValueString)(additionalProps, currentComponentSchema.customValue)
                : currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.label,
            textfit: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.textFit,
            textOptions: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.textOptions,
            infopageValue: infopageContent ? infopageContent[currentComponentSchema.id] : undefined
        };
    }
    else if (CurrentComponent === LunchItems_1.default) {
        customAttributes = {
            lunchItems: items,
            templateChildren: (currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.children) || [],
            mediaKeys: mediaKeys
        };
        // make sure to end recursion when LunchItems component
        componentChildren = undefined;
    }
    else if (CurrentComponent === Components_1.LunchGroups) {
        customAttributes = {
            groups: items,
            templateChildren: (currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.children) || [],
            mediaKeys: mediaKeys
        };
        // make sure to end recursion when LunchGroups component
        componentChildren = undefined;
    }
    else if (CurrentComponent === ListPrice_1.default) {
        customAttributes = {
            listPrice: listPrice,
            templateChildren: (currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.children) || []
        };
        // make sure to end recursion when ListPrice component
        componentChildren = undefined;
    }
    else if (CurrentComponent === Products_1.default) {
        customAttributes = {
            mediaKeys: mediaKeys,
            items: items,
            templateChildren: (currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.children) || [],
            currentComponentSchema: currentComponentSchema,
            additionalProps: additionalProps
        };
        componentChildren = undefined;
    }
    else if (CurrentComponent === Components_1.ProductData) {
        customAttributes = {
            mediaKeys: mediaKeys,
            items: items,
            templateChildren: (currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.children) || [],
            currentComponentSchema: currentComponentSchema
        };
        // make sure to end recursion when ProductData component
        componentChildren = undefined;
    }
    else if (CurrentComponent === Components_1.PriceItems ||
        CurrentComponent === Components_1.FishItems ||
        CurrentComponent === Components_1.MeatItems ||
        CurrentComponent === Components_1.KeskoFeedOffers || // NOTE: KeskoFeedOffers and KeskoProductOffers will be deprecated soon. As template editor support creating feed templates
        CurrentComponent === Components_1.KeskoProductOffers) {
        customAttributes = {
            mediaKeys: mediaKeys,
            items: items,
            templateChildren: (currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.children) || [],
            chain: chain
        };
        // make sure to end recursion when
        // PriceItems, FishItems, MeatItems, KeskoFeedOffers or KeskoProductOffers component
        componentChildren = undefined;
    }
    else if (CurrentComponent === Components_1.Image) {
        var key = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.key;
        var src = (0, infopages_1.getMediaPath)(mediaKeys, key, infopageContent === null || infopageContent === void 0 ? void 0 : infopageContent[currentComponentSchema.id], contentMetadata);
        customAttributes = {
            src: src,
            alt: ''
        };
        // make sure to end recursion when Image component
        componentChildren = undefined;
    }
    else if (CurrentComponent === Components_1.Video) {
        var key = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.key;
        // video set in template editor
        var src = (0, infopages_1.getMediaPath)(mediaKeys, key, infopageContent === null || infopageContent === void 0 ? void 0 : infopageContent[currentComponentSchema.id], contentMetadata);
        customAttributes = {
            src: src,
            videoAttributes: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.videoAttributes
        };
        // make sure to end recursion when Image component
        componentChildren = undefined;
    }
    else if (CurrentComponent === Components_1.Date) {
        customAttributes = {
            dateOptions: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.dateOptions
        };
        // make sure to end recursion when Image component
        componentChildren = undefined;
    }
    else if (CurrentComponent === Components_1.QrCode) {
        customAttributes = {
            qrCodeOptions: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.qrCodeOptions
        };
        // make sure to end recursion when SocialMedia component
        componentChildren = undefined;
    }
    else if (CurrentComponent === Components_1.Div) {
        if (infopageContent) {
            var backgroundImage = (0, infopages_1.getMediaPath)(mediaKeys, null, infopageContent === null || infopageContent === void 0 ? void 0 : infopageContent[currentComponentSchema.id], contentMetadata);
            // set user defined backgroundImage if found
            if (backgroundImage) {
                currentComponentStyles.backgroundImage = "url(".concat(backgroundImage, ")");
            }
        }
        customAttributes = {
            effects: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.effects
        };
    }
    if (CurrentComponent) {
        var willRender = (0, conditions_1.willComponentRender)(additionalProps, currentComponentSchema.conditions);
        return willRender ? (react_1.default.createElement(CurrentComponent, __assign({ id: currentComponentSchema.id, styles: currentComponentStyles }, customAttributes), componentChildren &&
            Object.values(componentChildren).map(function (schema, index) {
                var templateProps = {
                    currentComponentSchema: schema,
                    currentTemplate: currentTemplateChildren ? currentTemplateChildren[index] : {},
                    mediaKeys: mediaKeys,
                    items: items,
                    infopageContent: infopageContent,
                    contentMetadata: contentMetadata,
                    chain: chain,
                    listPrice: listPrice,
                    additionalProps: additionalProps,
                    editorConfigurations: editorConfigurations
                };
                return react_1.default.createElement(RecursiveTemplateSchema, __assign({ key: "".concat(schema.id, "-").concat(index) }, templateProps));
            }))) : (react_1.default.createElement(react_1.Fragment, { key: "".concat(currentComponentSchema.id, "-none") }));
    }
    else {
        return react_1.default.createElement(react_1.Fragment, null);
    }
};
exports.default = RecursiveTemplateSchema;
//# sourceMappingURL=RecursiveTemplate.js.map